import { APIError, useApplicantAPI, useRequest } from "@certn/api";
import { showToast } from "@certn/cascadia";
import {
  BasicButton,
  DangerButton,
  ButtonGroup,
  Text,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

type DeclineModalProps = {
  applicantId: string;
  show: boolean;
  onClose: () => void;
  teamName?: string | null;
};

export function DeclineModal({
  applicantId,
  show,
  onClose,
  teamName,
}: DeclineModalProps) {
  const { t } = useTranslation();
  const request = useRequest();
  const [isLoading, setIsLoading] = useState<boolean>();
  const { mutate } = useApplicantAPI("/api/internal/applicant/case/open/");
  const { mutate: mutateComplete } = useApplicantAPI(
    "/api/internal/applicant/case/complete/"
  );

  const declineRequest = async () => {
    setIsLoading(true);
    try {
      await request(`/api/internal/applicant/case/${applicantId}/decline/`, {
        method: "POST",
      });
      showToast(t("Check successfully declined."));
      await mutate();
      await mutateComplete();
      onClose();
    } catch (e) {
      if (e instanceof APIError) {
        showToast(t("Something went wrong, try again"), { type: "error" });
      }
    }
    setIsLoading(false);
  };

  if (!show) {
    return null;
  }
  return (
    <Modal isOpen={show}>
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={onClose}>
              {t("Decline request")}
            </DialogHeader>
            <DialogContent>
              <>
                <div>
                  <Text style="form/body-primary" color="text-weak">
                    <Trans>
                      If you've decided not to proceed with the background check
                      for {{ teamName }} select the “Decline request“ button
                      below. Once confirmed, {{ teamName }} will be notified and
                      the check will be cancelled.
                    </Trans>
                  </Text>
                </div>
                <br />
                <br />
                <div>
                  <Text style="form/body-primary" color="text-weak">
                    <Trans>
                      Please note that this action cannot be undone.
                    </Trans>
                  </Text>
                </div>
              </>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <BasicButton size="medium" onPress={onClose}>
                  <Trans>Go back</Trans>
                </BasicButton>
                <DangerButton
                  testID="decline-request-button"
                  size="medium"
                  onPress={declineRequest}
                  isLoading={isLoading}
                >
                  <Trans>Decline request</Trans>
                </DangerButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
